<h1 mat-dialog-title class="pt-2 text-center"> Choix des techniciens</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row">
            <div class="col-12 col-md-6">

                <mat-form-field class="w-100">
                    <mat-select placeholder="Agence" [(ngModel)]="SelectedAgency" [compareWith]="compareAgencyWith" (selectionChange)="getSamplerOfSelectedAgency()">
                        @for (agency of AgencyList; track agency; let i = $index) {
                        <mat-option [value]="agency">
                            {{ agency.Name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
                <mat-form-field class="w-100">
                    <mat-select placeholder="Technicien" [(ngModel)]="SelectedTechnicianList" multiple [compareWith]="compareUserWith" (selectionChange)="getSelectedTechnicien($event);">
                        @for (tech of TechnicianList; track tech; let i = $index) {
                        <mat-option [value]="tech" [disabled]="LoadingTask.IsLoading > 0">
                            {{ tech.FirstName }} {{ tech.LastName }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        
        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
                Ajouter
            </button>
        </div>
    </div>
</div>